import axios from 'axios'
import { BASE_URL } from './base-url'

var base = BASE_URL;

/* MODELS

Video = {
    "id": 1,
    "uuid": "uuid",
    "title": "title",
    "description": "description",
    "author": "author",
    "thumbnail": "/path/to/thumbnail",
    "type": "vod",
    "sourcePath": "/path/to/source/video",
    "encodedPath": "/path/to/encoded/video",
    "encodingStatus": "to_encode",
    "createdAt": "2018-04-19T08:53:15.000Z",
    "updatedAt": "2018-04-19T08:53:15.000Z",
    "client_id": 1,
    "user_id": 1
}

VideoRegisterForm = {
    "title": "Video title",
    "description": "Video description",
    "author": "Video author",
    "type": "vod"
    "url": "http://example.com/url.html", ==> If type = live
    "video": file, ==> If type = vod
}

VideoPut = {
    "title": "Title",
    "description": "Description",
    "author": "Author"
}

Representation: [
    {
        "id": 1,
        "fps": 30,
        "segmentDuration": 6,
        "gopSize": 4,
        "video_id": 1,
        "options": "",
        "Resolutions": [
            {
                "id": 1,
                "width": 1920,
                "height": 1080,
                "representation_id": 1,
                "Bitrates": [
                    {
                        "id": 1,
                        "bitrate": 1200,
                        "resolution_id": 1
                    },
                    {
                        "id": 2,
                        "bitrate": 2100,
                        "resolution_id": 1
                    }
                ]
            }
        ]
    }
]

RepresentationRegister = {
    "fps": 30,
    "segmentDuration": 6,
    "gopSize": 4,
        "options": "",
    "resolutions": [
        {
            "width": 1920,
            "height": 1080,
            "bitrates": [1200, 2100]
        }
    ]
}

*/


/**
 * Implements Categories endpoints from https://github.com/dngroup/msstream-platform/wiki/Upload-Manager-API#videos
 */
export default class VideoService {

    /**
     * Get all videos for the client. with pagination
     * 
     * @param {string} token 
     * @return {[Video]}
     */
    getVideosPageForClient(token, pagination) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/videos',
                method: 'get',
                params: pagination,
                withCredentials: true,
headers: {                   'Authorization': token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getVideoListPlugin(token,data)
    {
      return new Promise((done, reject) => {
        var instance = {
          baseURL: base + '/api/videosplugin',
          method: 'get',
          params: data,
          withCredentials: true,
headers: {           'Content-Type': 'application/json',
            'Authorization': token
          },
        };
        axios(instance).then((response) => {
          done(response.data);
        }).catch((error) => {
          reject(error);
        })
      });
    }

    refreshVideoPlugin(token, params)
    {
      return new Promise((done, reject) => {
        var instance = {
          baseURL: base + '/api/refreshvideosplugin',
          method: 'get',
          withCredentials: true,
headers: {           'Content-Type': 'application/json',
            'Authorization': token
          },
          params:params
        };
        axios(instance).then((response) => {
          done();
        }).catch((error) => {
          reject(error);
        })
      });
    }

    

    /**
     * Get video with the given {videoId}.
     * 
     * @param {string} videoId 
     * @param {string} token 
     * @return {Video}
     */
    getVideoById(videoId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videos/${videoId}`,
                method: 'get',
                withCredentials: true,
headers: {                   'Authorization': token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get plugin video.
     */
    getVideoPlugin(video, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videosplugin/${video.configKey}/${video.videoID}`,
                method: 'get',
                withCredentials: true,
                headers: { Authorization: token },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

        /**
     * Update plugin video with the the given {videoId}.
     * 
     * @param {VideoRegisterPut} video
     * @param {string} videoId 
     * @param {string} token 
     * @return {Video}
     */
         putVideoPluginById(video, videoId, token) {
            return new Promise((done, reject) => {
                var instance = {
                    baseURL: base + `/api/videosplugin/${videoId}`,
                    method: 'put',
                    withCredentials: true,
headers: {                       'Authorization': token,
                        'Content-Type': 'application/json',
                    },
                    data: video
                };
                axios(instance).then((response) => {
                    done(response.data);
                }).catch((error) => {
                    reject(error);
                })
            });
        }


    /**
     * Update plugin video.
     */
    putVideoPlugin(videoConfig, video, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videosplugin/${video.configKey}/${video.videoID}`,
                method: 'put',
                withCredentials: true,
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                },
                data: videoConfig
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }


    /**
 * Update video with the the given {videoId}. Requires 'Administrator' or 'Manage videos' privilege.
 * 
 * @param {VideoRegisterPut} video
 * @param {string} videoId 
 * @param {string} token 
 * @return {Video}
 */
    putVideoAdmin(video, videoId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/videosadmin/${videoId}`,
                method: 'put',
                withCredentials: true,
headers: {                   'Authorization': token,
                    'Content-Type': 'application/json',
                },
                data: video
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Refresh encoders
     * 
     * 
     */
     postRefresh(token) {
        return new Promise((done, reject) => {
            var instance = {
                url: base + '/api/refresh',
                method: 'post',
                withCredentials: true,
headers: {                   'Authorization': token
                },
                data: {}
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }
}